import AxiosClient from '@services/api/base'
import routes from '@configs/api'
import { Course } from '@ugu/types'
import { AUTH_TOKEN_KEY } from '@constants/localstorageKeys'
import Cookies from 'js-cookie'

// TODO - Refactor according to new api specs
/**
 * Publish Course - Send for review
 * @param course
 * @param reviewNote
 * @param contactEmail
 */
const publishCourse = (
  course_id: string,
  version: number,
  reviewNote: string,
  contactEmail: string,
  pubOptions: {
    publishMode: 'immediate' | 'scheduled'
    publishAt?: Date
  }
): Promise<Course> => {
  return new Promise((resolve, reject) => {
    const tokenId = Cookies.get(AUTH_TOKEN_KEY)
    const URL = routes.COURSE + course_id + '/' + version + '/publish'
    const data = {
      reviewNote,
      contactEmail,
      ...pubOptions,
    }
    const config = {
      headers: {
        Authorization: `Bearer ${tokenId}`,
      },
    }
    AxiosClient.post(URL, data, config)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export default publishCourse
